<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
      // 根据不同路由跳转不同页面
  //     if (this._isMobile()) {
  //       console.log('手机端')
		// window.location.replace(`https://wap.oliender.com/`);
  //     } else {
  //       console.log('pc端')
  //     }
    },
    methods: {
      // 判断是否是手机端，如果是，返回true
      _isMobile () {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag
      }
    }
}
</script>

<style>
.el-input-group__append, .el-input-group__prepend{
    background: #287EFF!important;
    color: #fff!important;
    border: 1px solid #287EFF!important;
  }
  .el-input-group--append .el-input__inner, .el-input-group__prepend{
     border: 1px solid #287EFF!important;
  }
.el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #287EFF!important;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
	background-color: #fff!important;
}
.el-pager li:hover{
	color: #287EFF!important;
}
.el-radio__input.is-checked .el-radio__inner{
		border-color: #287EFF!important;
		background: #287EFF!important;
	}
	.el-radio__input.is-checked+.el-radio__label {
	    color: #287EFF!important;
	}
  * {
	  padding: 0;
	  margin: 0;

  }
  body {
	  background: #F6F5F7;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue